import { FormCompletionModel } from '../models/FormCompletionModel';

export class FormCompletionDto extends FormCompletionModel {
  public CompletedByUserName?: string;
  public OwnedByUserName?: string;
  public TemplateName?: string;
  public SubmissionName?: string;
  public Color?: string;
}